<template>
  <div>
    <!--タイトル-->
    <header id="header">
      <Header title-image="static/images/common/logo-projection.svg" can-back-flag="1"></Header>
    </header>

    <!--一覧-->
    <div id="wrapper">
      <div class="content">

        <section class="projection-list-box">
          <ul>
            <li><a href="#" v-on:click.prevent='linkAction' data-id="1" target="_blank" rel="noopener"><span>1 さまざまな時代の地図</span></a></li>
            <li><a href="#" v-on:click.prevent='linkAction' data-id="2" target="_blank" rel="noopener"><span>2 地図投影法・地球儀・時差</span></a></li>
          </ul>
        </section>

      </div>
    </div>

  </div>
</template>

<script>
import Header from '@/components/modules/Header'
import router from '@/router'
import cmd from '@/common/Command'

export default {
  mounted: function () {

    $("body").removeClass()
    $("body").addClass("page-low")
    $("body").addClass("cat-projection")
    $("body").addClass("page-projection-index")
    cmd.adjustStyle()

  },
  methods: {
    linkAction (e) {
      var element = e.currentTarget
      var id = element.getAttribute('data-id')
      var resolvedRoute = router.resolve({
        name: 'projectionDetail',
        params: {id: id}
      });
      window.open(resolvedRoute.href, '_blank');
    }
  },
  computed: {
  },
  components: {
    Header
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/ProjectionList.vue